module.exports = __webpack_public_path__ + "img/guide-cod-2-pop.f20f4a05.png";